"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _GoogleMapsComponent = _interopRequireDefault(require("../../components/GoogleMaps/GoogleMapsComponent"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * A AgencySearch component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.JSX.Element} A Search component created for MMFA Careers subdomain
 */
function AgencySearch(props) {
  var _props$rendering;
  if (!((_props$rendering = props.rendering) !== null && _props$rendering !== void 0 && _props$rendering.fields)) return null;
  var [inputBoxValue, setInputBoxValue] = (0, _react.useState)('');
  var [inputBoxError, setInputBoxError] = (0, _react.useState)(false);
  var [addressArray, setAddressArray] = (0, _react.useState)([]);
  var [selectedIdx, setSelectedIdx] = (0, _react.useState)(-1);
  var [agencyArray, setAgencyArray] = (0, _react.useState)([]);
  var [agencyArrayForMap, setAgencyArrayForMap] = (0, _react.useState)([]);
  var [sessionToken, setSessionToken] = (0, _react.useState)((0, _lodash.random)(987654321));
  var [selectedOptionObj, setSelectedOptionObj] = (0, _react.useState)('');
  var [label, setLabel] = (0, _react.useState)('Within 20 miles');
  var [miles, setMiles] = (0, _react.useState)('20');
  var [mapCenterLocation, setMapCenterLocation] = (0, _react.useState)({});
  var [isInitialSearchDone, setIsInitialSearchDone] = (0, _react.useState)(false);
  var [searchInProgress, setSearchInProgress] = (0, _react.useState)(false);
  var dropdownArray = [{
    label: 'Within 1 mile',
    mileValue: '1'
  }, {
    label: 'Within 5 miles',
    mileValue: '5'
  }, {
    label: 'Within 10 miles',
    mileValue: '10'
  }, {
    label: 'Within 20 miles',
    mileValue: '20'
  }, {
    label: 'Within 50 miles',
    mileValue: '50'
  }, {
    label: 'Within 50+ miles',
    mileValue: '9999'
  }];
  var [showPlusInfo, setShowPlusInfo] = (0, _react.useState)(false);

  // useEffects
  (0, _react.useEffect)(() => {
    if (selectedOptionObj === '' || searchInProgress === true) return;
    setSearchInProgress(true);
    setShowPlusInfo(false);
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'distance': miles,
        'placeId': selectedOptionObj.place_id
      })
    };
    fetch(_constants.FETCH_AGENCY_LIST, requestOptions).then(res => res.json()).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (result) {
        setAgencyArray((0, _lodash.get)(result, 'searchResults'));
        setMapCenterLocation((0, _lodash.get)(result, 'mapCenterLocation'));
        var milesUsed = (0, _lodash.get)(result, 'milesUsed');
        var isMilesChanged = miles !== milesUsed;
        if (isMilesChanged && milesUsed === '9999') setShowPlusInfo(true);
        var dropDownValues = (0, _lodash.find)(dropdownArray, {
          mileValue: milesUsed
        });
        setMiles(dropDownValues.mileValue);
        setLabel(dropDownValues.label);
        setSearchInProgress(false);
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), error => {
      console.error('Error in useEffect : miles ');
      console.error(error);
    });
  }, [miles]);
  (0, _react.useEffect)(() => {
    setAgencyArrayForMap(agencyArray);
  }, [agencyArray]);
  (0, _react.useEffect)(() => {
    setAgencyArrayForMap(agencyArray);
  }, [mapCenterLocation]);

  // Event Handlers
  var handleOnChange = e => {
    setInputBoxError(false);
    setInputBoxValue(e.target.value);
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        searchWord: e.target.value,
        sessiontoken: sessionToken
      })
    };
    fetch(_constants.FETCH_AGENCY_ADDRESS_AUTOCOMPLETE, requestOptions).then(res => res.json()).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (result) {
        setAddressArray(result);
        setSelectedIdx(-1);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), error => {
      console.error(error);
    });
  };
  var handleOnSearchStart = () => {
    if (addressArray.length !== 0) {
      var firstPlaceId = addressArray[0].place_id;
      setSelectedOptionObj(addressArray[0]);
      searchAgency(firstPlaceId);
    } else if (addressArray.length === 0 && inputBoxValue === '') {
      setInputBoxError(true);
      setIsInitialSearchDone(false);
      setAgencyArray([]);
    }
  };
  var searchAgency = placeId => {
    var placeObj = (0, _lodash.find)(addressArray, {
      'place_id': placeId
    });
    setSelectedOptionObj(placeObj);
    setInputBoxValue(placeObj.description);
    setSearchInProgress(true);
    setShowPlusInfo(false);
    var milesToBeUsed = miles;
    if (isInitialSearchDone === true && miles === '9999') milesToBeUsed = '20';
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'distance': milesToBeUsed,
        'placeId': placeId
      })
    };
    fetch(_constants.FETCH_AGENCY_LIST, requestOptions).then(res => res.json()).then(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (result) {
        setAgencyArray((0, _lodash.get)(result, 'searchResults'));
        setMapCenterLocation((0, _lodash.get)(result, 'mapCenterLocation'));
        var milesUsed = (0, _lodash.get)(result, 'milesUsed');
        if (milesUsed === '9999') setShowPlusInfo(true);
        var dropDownValues = (0, _lodash.find)(dropdownArray, {
          mileValue: milesUsed
        });
        setMiles(dropDownValues.mileValue);
        setLabel(dropDownValues.label);
        setAddressArray([]);
        setIsInitialSearchDone(true);
        setSearchInProgress(false);
      });
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }(), error => {
      console.error('Error in searchAgency');
      console.error(error);
    });
  };
  var handleSelectedOption = event => {
    var autoCompletePlaceIdValue = event.target.value;
    var placeObj = (0, _lodash.find)(addressArray, {
      'place_id': autoCompletePlaceIdValue
    });
    setSelectedOptionObj(placeObj);
    setInputBoxValue(placeObj.description);
    searchAgency(autoCompletePlaceIdValue);
  };
  var clickHandler = (label, miles) => () => {
    setLabel(label);
    setMiles(miles);
  };
  var handleEnterPress = () => {
    if (addressArray.length !== 0) {
      var firstPlaceId = addressArray[selectedIdx].place_id;
      setSelectedOptionObj(addressArray[selectedIdx]);
      searchAgency(firstPlaceId);
    } else if (addressArray.length === 0 && inputBoxValue === '') {
      setInputBoxError(true);
    }
  };
  var handleKeyPress = event => {
    if (event.keyCode === 13 && selectedIdx !== -1) {
      handleEnterPress();
    }
    if (event.keyCode === 13 && selectedIdx === -1 && !(0, _lodash.isEmpty)(addressArray)) {
      handleOnSearchStart();
    }
    if (event.keyCode === 38 && selectedIdx > 0) {
      setSelectedIdx(selectedIdx - 1);
    }
    if (event.keyCode === 40 && addressArray.length > selectedIdx + 1) {
      setSelectedIdx(selectedIdx + 1);
    }
  };

  // Rendering functions
  var renderSuggestion = () => {
    if ((addressArray === null || addressArray === void 0 ? void 0 : addressArray.length) > 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: "0",
        className: "list-group sch-div",
        style: {
          width: 'inherit'
        }
      }, (0, _lodash.map)(addressArray, (eachElem, idx) => {
        return /*#__PURE__*/_react.default.createElement("button", {
          key: eachElem.place_id,
          id: idx,
          value: eachElem.place_id,
          onClick: handleSelectedOption,
          className: "list-group-item list-group-item-action sch-button sch-list-grp ".concat(selectedIdx === idx ? 'sch-button-active' : '')
        }, eachElem.description);
      }));
    }
  };
  var renderAgencyList = (0, _lodash.map)(agencyArray, eachElem => {
    var websiteurl = !(0, _lodash.isEmpty)(eachElem.agencyWebsiteurl) ? eachElem.agencyWebsiteurl : 'https://www.massmutual.com';
    var geoCityState = _.filter([eachElem.state, eachElem.zip]).join(' ');
    var geoAddress = _.filter([eachElem.address1, eachElem.city, geoCityState]).join(', ');
    var streetAddress = [eachElem.address1, eachElem.address2, eachElem.address3].filter(val => val).join(', ');
    var cityStateZip = _.filter([eachElem.city, geoCityState]).join(', ');
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.ListGroup.ListGroupItem, {
      key: eachElem._id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "h3"
    }, eachElem.agencyName), /*#__PURE__*/_react.default.createElement("p", null, streetAddress, /*#__PURE__*/_react.default.createElement("br", null), cityStateZip), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "//www.google.com/maps?q=".concat(geoAddress),
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-external-link"
    }), " \xA0 Directions"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "mm-text-right",
      href: "tel:".concat(eachElem.phone)
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-call"
    }), " \xA0 ", eachElem.phone))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
      href: websiteurl,
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-external-link"
    }), " \xA0 Visit Agency Website"))))));
  });
  var renderDropdown = (0, _lodash.map)(dropdownArray, (eachItem, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.DefaultItem, {
      key: index,
      eventKey: index,
      onClick: clickHandler(eachItem.label, eachItem.mileValue)
    }, eachItem.label);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "suggestionform"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    "aria-describedby": "agency-search-input",
    "aria-label": "Search Term",
    className: "form-control ".concat(inputBoxError ? 'is-invalid' : ''),
    id: "agency-search-input",
    "data-testid": "agency-search-input",
    onChange: handleOnChange,
    onKeyDown: handleKeyPress,
    placeholder: "ZIP Code or City, State",
    type: "text",
    value: inputBoxValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    type: "button",
    id: "search-start",
    onClick: handleOnSearchStart
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Search"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-search",
    "aria-hidden": "true",
    title: "Search"
  })))), renderSuggestion())))), isInitialSearchDone && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "vertical-align"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 3,
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Distance:")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
    id: "miles_dropdown_id",
    type: "default"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
    id: "miles-dropdown-toggle-id",
    label: label
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
    id: "dropdown-menu"
  }, renderDropdown))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 7,
    className: "mm-spacing--minor"
  }, showPlusInfo === true ? /*#__PURE__*/_react.default.createElement("div", {
    role: "alert",
    className: "alert alert-info"
  }, /*#__PURE__*/_react.default.createElement("p", null, "The nearest main office is 50+ miles away. That\u2019s OK \u2014 select a main office and we\u2019ll be in touch if we find an opportunity that\u2019s right for you.")) : undefined)), /*#__PURE__*/_react.default.createElement("h3", null, agencyArray.length, " Agencies near '", inputBoxValue, "'")), agencyArrayForMap.length > 0 && !searchInProgress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "card--basic no-border card",
    style: {
      height: '50rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row",
    style: {
      minHeight: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-6",
    style: {
      overflowY: 'scroll',
      maxHeight: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.ListGroup, null, renderAgencyList))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 12,
    lg: 6,
    className: "mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement(_GoogleMapsComponent.default, {
    agencyArray: agencyArray,
    mapCenterLocation: mapCenterLocation
  })))))));
}
var _default = exports.default = AgencySearch;